module.exports = __webpack_public_path__ + "static/img/groundHome14.2bca13c0.png";